import { defaultLayoutDimensions } from "src/organization/pages/project/environment/metrics/http/config";
import useUpdateDimension from "src/organization/pages/project/environment/metrics/http/hook/useUpdateDimension";

const dimension = { ...defaultLayoutDimensions, height: 240 };
export const useUpdateResourceDimension = (id: string) => {
  return useUpdateDimension(id, dimension);
};
